import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { FormHelperService } from '../../../services/form-helper.service';
import { DropdownService } from '../../../services/dropdown-service';
import { LookupItem } from '../../../components/utils/models/lookupItem';
import { Bank } from '../../../components/utils/models/bank';
import { RichFormComponent } from '../../../components/library/rich-form/rich-form.component';

@Component({
  selector: 'app-direct-debit-instructions',
  templateUrl: './direct-debit-instructions.component.html',
  styleUrl: './direct-debit-instructions.component.scss'
})
export class DirectDebitInstructionsComponent {
  @Input() accountTypes!: Array<any>;
  @Input() formGroupName!: string;
  directDebitInstructionsForm!: FormGroup;
  @Output() isDataChanged = false;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();

  addressForm!: FormGroup;
  formUiWidgets!: Record<string, any>[];
  savedDebitInstructions!: Record<string, any>;
  debitInstructionsData!: Record<string, any>;
  isLoading = false;
  isContentScrolled = false;
  banksNameList!: Array<string>;
  banksList!: Array<Bank>;
  @ViewChild('directDebitFormComponent') directDebitFormComponent!: RichFormComponent;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private _formHelper: FormHelperService,
    private _DropdownService: DropdownService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this._DropdownService.GetBanks().subscribe(resp => {
      this.banksNameList = resp.map(function (v) {
        return v.description;
      });
      this.banksList = resp;
      this.banksList = this.banksList.sort((a, b) => {
        return a.description.localeCompare(b.description)
      });

      this.directDebitInstructionsForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
      this.formUiWidgets = this.getFormControls();

      this.debitInstructionsData =
      {
        "bankname": "",
        "branchcode": "",
        "account": "",
      }

      this.cdr.detectChanges();
      this.isLoading = false;
    });
  }


  getFormControls() {
    return [
      {
        label: 'Bank',
        dataField: 'bankname',
        editorType: 'dxSelectBox',
        colSpan: 1,
        width: '150px',
        editorOptions: {
          items: this.banksNameList,
          searchEnabled: true,
        },
        validators: [
          {type : 'required'}
        ],
        FormType: 'DebitInstructions'
      },
      {
        label: 'Branch Code',
        editorType: 'dxTextBox',
        dataField: 'branchcode',
        colSpan: 1,
        width: '150px',
        validators: [
          { type: 'required' }
        ],
        FormType: 'DebitInstructions',
        editorOptions: {
          disabled: true,
          elementAttr: {
            style: 'background-color: rgb(238, 238, 238);padding-top:5px;'
          }
        },
      },
      {
        label: 'Account Number',
        dataField: 'account',
        editorType: 'dxNumberBox',
        colSpan: 1,
        width: '150px',
        FormType: 'DebitInstructions',
        validators: [
          { type: 'required' }
        ],
        editorOptions: {
          maxLength : 11,
          maxLengthMessage: 'Account number must be at most 11 characters long.',
          format : '#',
        },
        
      }
    ]
  }

  scroll({ reachedTop = false }) {
    this.isContentScrolled = !reachedTop;
  }

  dataChanged(object) {
    if ('event' in object) {

      if (typeof object.event.value === 'string' || object.event.value instanceof String) {

        let formValue: String = object.event.value;
        formValue = formValue.trim();
        
        this.directDebitInstructionsForm.patchValue({
          [object.event.dataField]: formValue
        });

      }
      else {

        this.directDebitInstructionsForm.patchValue({
          [object.event.dataField]: object.event.value
        });
      }
     
      if (object.event.dataField == 'bankname') {
        let findBank = this.banksList.find(item => item.description == object.event.value);

        if (findBank != null) {
          this.debitInstructionsData['branchcode'] = findBank.branchCodeUniversal
        }

      }
    }

    this.notifyContainerDataChanged.emit(object);
  }

  cancel() {

      this.debitInstructionsData =
      {
        "bankname": undefined,
        "branchcode": undefined,
        "account": undefined,
      }
     this.cdr.detectChanges();

  }

}
